import {Component} from '@angular/core';
import {FilterConfig, GridPageComponent} from "../../../common/grid-page.component";
import {FacilityUtilizationGridViewDto} from "@services";
import {CommonModule} from "@angular/common";
import {
    DxDataGridModule,
    DxFormModule,
    DxTemplateModule
} from "devextreme-angular";
import {FilterPanelComponent} from "../../../../components/library/filter-panel/filter-panel.component";

@Component({
    selector: 'app-facility-utilization',
    standalone: true,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxFormModule,
        DxTemplateModule,
        FilterPanelComponent
    ],
    templateUrl: './facility-utilization.component.html',
    styles: [
        `.grid {
            height: calc(100vh - 150px);
        }`
    ]
})
export class FacilityUtilizationComponent extends GridPageComponent<FacilityUtilizationGridViewDto> {

    constructor() {
        super();
        this.init(FacilityUtilizationGridViewDto);
    }

    readonly numberFormat = "#,##0";
    readonly percentFormat = "#0.#%";

    dataSource = this.dataSources.facilityUtilization();

    private createPercentFilter = (field: string) => (filterValue: any, selectedFilterOperation: string) => {
        if (filterValue === undefined || filterValue === null) {
            return null;
        }
        return [field, selectedFilterOperation || '>=', filterValue / 100];
    };

    coolerUtilizationFilter = this.createPercentFilter('coolerUtilization');
    ambientUtilizationFilter = this.createPercentFilter('ambientUtilization');
    utilizationFilter = this.createPercentFilter('utilization');

    protected override exportName: string = "FacilityUtilization";

    protected override filterConfig: FilterConfig[] = [
        {field: 'created', op: '>='},
        {field: 'coolerCapacity', op: '>='},
        {field: 'actualUsageCooler', op: '>='},
        {field: 'coolerUtilization', op: '>=', customFilter: this.coolerUtilizationFilter},
        {field: 'ambientCapacity', op: '>='},
        {field: 'actualUsageAmbient', op: '>='},
        {field: 'ambientUtilization', op: '>=', customFilter: this.ambientUtilizationFilter},
        {field: 'footprintCapacity', op: '>='},
        {field: 'actualUsage', op: '>='},
        {field: 'utilization', op: '>=', customFilter: this.utilizationFilter},
        {field: 'gerber', op: '>='},
        {field: 'boost', op: '>='},
        {field: 'vitality', op: '>='},
        {field: 'pallets', op: '>='},
        {field: 'starbucks', op: '>='},
        {field: 'ambientDeadEnd', op: '>='},
        {field: 'coolerDeadEnd', op: '>='},
        {field: 'floorFl', op: '>='},
        {field: 'emptyBins', op: '>='},
        {field: 'palletPositionsAvailable', op: '>='},
    ];
}
